import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/yuz-dolgusunun-alerji-riski-nadir-ama-bilinmesi-gereken-gercekler/page.tsx");
